<template>
  <span>
    <CreateFlag
      v-if="canCreate"
      :target="target"
      :profile="profile"
      :filter="filter"
      :tooltip="tooltipLines"
      @done="$emit('done')"
    >
      <v-btn icon flat :color="buttonColor" class="ma-0" slot="activator">
        <v-icon>{{ buttonIcon }}</v-icon>
      </v-btn>
    </CreateFlag>
    <v-tooltip v-else-if="primaryFlagDefinition" bottom>
      <v-btn icon flat :color="buttonColor" class="ma-0" slot="activator">
        <v-icon>{{ buttonIcon }}</v-icon>
      </v-btn>
      <div>
        <div v-for="(line, index) in tooltipLines" :key="`tooltip-line-${index}`">
          {{ line }}
        </div>
      </div>
    </v-tooltip>
  </span>
</template>

<script>
// Components
import CreateFlag from '@/components/flags/CreateFlag'

// Data
import flags from '@/data/flags'

// Helpers
import _ from 'lodash'

export default {
  components: { CreateFlag },

  props: {
    filter: { type: Array, default: () => [] },
    flags: { type: Array, default: () => [] },
    profile: { type: Object, default: () => null },
    target: { type: Object, default: () => null },
  },

  data() {
    return {
      availableFlags: flags,
    }
  },

  computed: {
    buttonColor() {
      if (!this.primaryFlagValue) return 'error'

      return this.primaryFlagValue.isSevere ? 'error' : 'warning'
    },

    buttonIcon() {
      return _.get(this, 'primaryFlagDefinition.icon', 'mdi-flag')
    },

    canCreate() {
      return Boolean(
        _.get(this, 'filter[0]') &&
          _.get(this, 'profile.id') &&
          _.get(this, 'target.id') &&
          _.get(this, 'target.type')
      )
    },

    primaryFlagDefinition() {
      if (!this.primaryFlagValue) return null

      return this.availableFlags.find(flag => flag.key === this.primaryFlagValue.key) || null
    },

    primaryFlagValue() {
      if (!_.get(this, 'flags[0]')) return null

      return (
        this.flags.find(flag => !flag.resolvedAt && flag.isSevere) ||
        this.flags.find(flag => !flag.resolvedAt) ||
        this.flags.find(flag => flag.isSevere) ||
        this.flags[0]
      )
    },

    tooltipLines() {
      if (!_.get(this, 'flags[0]')) return ['Click to flag']

      const lines = this.flags
        .map(flag => this.availableFlags.find(definition => definition.key === flag.key))
        .filter(Boolean)
        .map(flag => flag.name)

      if (this.canCreate) lines.push('Click to add another flag')

      return lines
    },
  },
}
</script>
